import type { MatchingOffers } from 'types/match'

import styled from 'styled-components'
import copy from 'copy.json'
import { formatDate } from 'utils'

import Button from 'components/Button'
import Status from 'components/Status'
import StyledModal from 'components/layout/StyledModal'

type Props = {
  reservationsHistory: MatchingOffers['reservations_history']
  isModalOpen: boolean
  onModalClose: () => void
  closeButtonLabel: string
}

const text = copy.modal.reservations_history

export default function ReservationsHistoryModal({
  reservationsHistory,
  isModalOpen,
  onModalClose,
  closeButtonLabel
}: Props) {
  return (
    <StyledModal isOpen={isModalOpen} onClose={onModalClose}>
      <h3>{text.title}</h3>

      {reservationsHistory?.map(
        ({
          status,
          continuation,
          created_by,
          created_date,
          from_date,
          last_modified_date,
          reason,
          to_date
        }) => (
          <Statuses key={created_date}>
            <Status statusType={status} />

            <StatusDetails>
              <Details>
                <p>{text.reservation}</p>
                <p>
                  {copy.common.from} {formatDate(from_date)} {copy.common.to} {formatDate(to_date)}
                </p>
              </Details>

              <Details>
                <p>{text.created_date}</p>
                <p>{formatDate(created_date)}</p>
              </Details>

              <Details>
                <p>{text.last_modified_date}</p>
                <p>{formatDate(last_modified_date)}</p>
              </Details>

              <Details>
                <p>{text.continuation}</p>
                <p>{continuation ? text.yes : text.no}</p>
              </Details>

              <Details>
                <p>{text.created_by}</p>
                <p>{created_by}</p>
              </Details>

              {reason && (
                <Details>
                  <p>{text.reason}</p>
                  <p>{reason}</p>
                </Details>
              )}
            </StatusDetails>
          </Statuses>
        )
      )}

      <Button onClick={onModalClose} style={{ width: '100%', maxWidth: 424 }}>
        {closeButtonLabel}
      </Button>
    </StyledModal>
  )
}

const Statuses = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  width: 100%;

  span:first-child {
    align-self: flex-start;
    padding: 0px max(8px, calc((100% - 600px) / 2));
  }
`

const StatusDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
  padding: 16px 24px;
  padding: 16px max(8px, calc((100% - 600px) / 2));

  background: var(--very-light-blue);
`

const Details = styled.div`
  display: flex;
  gap: 20px;

  font: var(--400-13);

  p:first-of-type {
    width: 90px;
    text-align: left;
    font: var(--600-13);
  }
`
